import { render, staticRenderFns } from "./detailOrder.vue?vue&type=template&id=358f8000&scoped=true"
import script from "./detailOrder.vue?vue&type=script&lang=js"
export * from "./detailOrder.vue?vue&type=script&lang=js"
import style0 from "./detailOrder.vue?vue&type=style&index=0&id=358f8000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f8000",
  null
  
)

export default component.exports